const active = 'active';
const $htmlBody = $('html, body');

$(document).on('click', '.tabs__link', (ev) => {
    if ('A' === ev.currentTarget.tagName) {
        ev.preventDefault();
    }

    const $Link = $(ev.currentTarget);
    const tabId = ev.currentTarget.hash;

    if ($Link.data('scroll') && !isMobileViewport()) {
        scrollToTab($Link);
    }

    $Link
        .closest('li')
        .addClass(active)
        .siblings()
        .removeClass(active);

    $(tabId)
        .addClass(active)
        .siblings()
        .removeClass(active);

    setTimeout(() => {
        $(window).trigger(NLMK.events.TABS_CHANGE);
    }, 90);
});

//
// utils
//
const scrollToTab = ($el) => {
    const $headBottom = $('.head__bottom');
    const headHeight = isDesktopViewport() ? $headBottom.height() : 0;

    $htmlBody.animate(
        {
            scrollTop: $el.offset().top - headHeight,
        },
        800,
    );
};

const isMobileViewport = () => {
    return window.matchMedia('(max-width: 767px)').matches;
};

const isDesktopViewport = () => {
    return window.matchMedia('(min-width: 1024px)').matches;
};



// WEBPACK FOOTER //
// ./js/main/module/tabs.js